(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-david-build-your-pc-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents !== 'number' || isNaN(cents)) cents = 0;
    format = format || '${{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      var n = (number / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return match ? format.replace(match[0], value) : (format + value);
  }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    attrs = attrs || {};
    Object.keys(attrs).forEach(function (k) {
      if (attrs[k] === undefined || attrs[k] === null || attrs[k] === false) return;
      if (k === 'html') { node.innerHTML = attrs[k]; return; }
      if (k === 'text') { node.textContent = attrs[k]; return; }
      if (k.indexOf('on') === 0 && typeof attrs[k] === 'function') { node.addEventListener(k.slice(2), attrs[k]); return; }
      node.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) node.appendChild(c); });
    return node;
  }

  var BuildYourPC = function (root) {
    this.root = root;
    var dataTag = root.querySelector('[data-byp-data]');
    var payload;
    try { payload = JSON.parse(dataTag.textContent); } catch (e) { payload = { categories: [], settings: {} }; }
    this.moneyFormat = payload.moneyFormat;
    this.settings = payload.settings || {};
    this.categories = (payload.categories || []).filter(function (c) { return c.key; });
    this.storageKey = 'byp-state-' + this.settings.sectionId;
    this.activeIndex = 0;
    this.selections = {}; // { categoryKey: { optionId: qty } }
    this.cache = {};

    this.qs = function (sel) { return this.root.querySelector(sel); };
    this.qsa = function (sel) { return Array.prototype.slice.call(this.root.querySelectorAll(sel)); };

    this.init();
  };

  BuildYourPC.prototype.init = function () {
    if (!this.categories.length) return;
    this.loadState();
    this.cacheDom();
    this.bindGlobalEvents();
    this.renderSidebar();
    this.renderSteps();
    this.renderMain();
    this.renderSummary();
  };

  BuildYourPC.prototype.cacheDom = function () {
    this.c = {
      sidebar: this.qs('[data-byp-sidebar]'),
      steps: this.qs('[data-byp-steps]'),
      grid: this.qs('[data-byp-grid]'),
      empty: this.qs('[data-byp-empty]'),
      crumb: this.qs('[data-byp-crumb]'),
      catTitle: this.qs('[data-byp-cat-title]'),
      catHelper: this.qs('[data-byp-cat-helper]'),
      sort: this.qs('[data-byp-sort]'),
      prev: this.qs('[data-byp-prev]'),
      next: this.qs('[data-byp-next]'),
      nextLabel: this.qs('[data-byp-next-label]'),
      pagerCount: this.qs('[data-byp-pager-count]'),
      previewImg: this.qs('[data-byp-preview-img]'),
      previewPlaceholder: this.qs('[data-byp-preview-placeholder]'),
      buildName: this.qs('[data-byp-build-name]'),
      buildSpec: this.qs('[data-byp-build-spec]'),
      totalPrice: this.qs('[data-byp-total-price]'),
      priceBreakdown: this.qs('[data-byp-price-breakdown]'),
      power: this.qs('[data-byp-power]'),
      powerLabel: this.qs('[data-byp-power-label]'),
      powerValue: this.qs('[data-byp-power-value]'),
      powerFill: this.qs('[data-byp-power-fill]'),
      lines: this.qs('[data-byp-lines]'),
      warning: this.qs('[data-byp-warning]'),
      warningText: this.qs('[data-byp-warning-text]'),
      warningToggle: this.qs('[data-byp-warning-toggle]'),
      warningList: this.qs('[data-byp-warning-list]'),
      addToCart: this.qs('[data-byp-add-to-cart]'),
      reset: this.qs('[data-byp-reset]'),
      mobilebar: this.qs('[data-byp-mobilebar]'),
      mobilePrice: this.qs('[data-byp-mobile-price]'),
      mobileExpand: this.qs('[data-byp-mobile-expand]'),
      mobileAdd: this.qs('[data-byp-mobile-add]'),
      overlay: this.qs('[data-byp-overlay]'),
      drawerBody: this.qs('[data-byp-drawer-body]'),
      drawerTotal: this.qs('[data-byp-drawer-total]'),
      drawerClose: this.qs('[data-byp-drawer-close]'),
      continueBtn: this.qs('[data-byp-continue]'),
      checkoutLink: this.qs('[data-byp-checkout]')
    };
  };

  BuildYourPC.prototype.loadState = function () {
    var saved = null;
    try { saved = JSON.parse(window.localStorage.getItem(this.storageKey)); } catch (e) { saved = null; }
    var valid = saved && typeof saved === 'object';
    this.categories.forEach(function (cat) {
      this.selections[cat.key] = {};
      var restored = valid && saved[cat.key];
      var hasRestored = false;
      if (restored) {
        Object.keys(restored).forEach(function (optId) {
          var opt = cat.options.filter(function (o) { return o.id === optId; })[0];
          if (opt && restored[optId] > 0) { this.selections[cat.key][optId] = restored[optId]; hasRestored = true; }
        }, this);
      }
      if (!hasRestored) {
        cat.options.forEach(function (opt) {
          if (opt.defaultSelected && opt.available) this.selections[cat.key][opt.id] = 1;
        }, this);
      }
    }, this);
  };

  BuildYourPC.prototype.saveState = function () {
    try { window.localStorage.setItem(this.storageKey, JSON.stringify(this.selections)); } catch (e) {}
  };

  BuildYourPC.prototype.money = function (cents) { return formatMoney(cents, this.moneyFormat); };

  BuildYourPC.prototype.groupedCategories = function () {
    var groups = [];
    var map = {};
    this.categories.forEach(function (cat) {
      var g = cat.group || '';
      if (!map[g]) { map[g] = { label: g, categories: [] }; groups.push(map[g]); }
      map[g].categories.push(cat);
    });
    return groups;
  };

  BuildYourPC.prototype.selectedOptionsForCategory = function (cat) {
    var sel = this.selections[cat.key] || {};
    return cat.options.filter(function (o) { return (sel[o.id] || 0) > 0; })
      .map(function (o) { return { option: o, qty: sel[o.id] }; });
  };

  BuildYourPC.prototype.firstSelected = function (cat) {
    var picked = this.selectedOptionsForCategory(cat);
    return picked.length ? picked[0].option : null;
  };

  BuildYourPC.prototype.categoryComplete = function (cat) {
    return this.selectedOptionsForCategory(cat).length > 0;
  };

  BuildYourPC.prototype.computeTotals = function () {
    var total = 0, base = 0, upgradeCount = 0, upgradeTotal = 0;
    this.categories.forEach(function (cat) {
      this.selectedOptionsForCategory(cat).forEach(function (row) {
        var line = row.option.price * row.qty;
        total += line;
        if (row.option.defaultSelected) {
          base += line;
        } else {
          upgradeCount += 1;
          upgradeTotal += line;
        }
      });
    }, this);
    return { total: total, base: base, upgradeCount: upgradeCount, upgradeTotal: upgradeTotal };
  };

  BuildYourPC.prototype.computePower = function () {
    var draw = 0, capacity = 0, hasSupplier = false;
    this.categories.forEach(function (cat) {
      var picked = this.selectedOptionsForCategory(cat);
      if (cat.addsPowerDraw) {
        picked.forEach(function (row) { draw += (row.option.wattage || 0) * row.qty; });
      }
      if (cat.isPowerSupplier && picked.length) {
        hasSupplier = true;
        capacity = Math.max(capacity, picked[0].option.psuRating || 0);
      }
    }, this);
    return { draw: draw, capacity: capacity, hasSupplier: hasSupplier };
  };

  BuildYourPC.prototype.computeConflicts = function () {
    var conflicts = [];

    // Socket compatibility
    var socketPicks = [];
    this.categories.forEach(function (cat) {
      if (!cat.isSocketLinked) return;
      var opt = this.firstSelected(cat);
      if (opt && opt.socket) socketPicks.push({ cat: cat, option: opt });
    }, this);
    if (socketPicks.length > 1) {
      var sockets = socketPicks.map(function (p) { return p.option.socket; });
      var uniq = sockets.filter(function (s, i) { return sockets.indexOf(s) === i; });
      if (uniq.length > 1) {
        socketPicks.forEach(function (p) {
          conflicts.push({
            categoryKey: p.cat.key,
            message: p.cat.title + ' (' + p.option.socket + ') doesn\u2019t match the socket of your other core-hardware choices.'
          });
        });
      }
    }

    // RAM slot capacity
    var slotCapacity = 0, slotProviderTitle = '';
    var slotUsed = 0, slotConsumerCats = [];
    this.categories.forEach(function (cat) {
      if (cat.isSlotProvider) {
        var opt = this.firstSelected(cat);
        if (opt) { slotCapacity = opt.ramSlots || 0; slotProviderTitle = opt.title; }
      }
      if (cat.isSlotConsumer) {
        slotConsumerCats.push(cat);
        this.selectedOptionsForCategory(cat).forEach(function (row) {
          slotUsed += (row.option.sticksPerKit || 1) * row.qty;
        });
      }
    }, this);
    if (slotCapacity > 0 && slotUsed > slotCapacity) {
      slotConsumerCats.forEach(function (cat) {
        conflicts.push({
          categoryKey: cat.key,
          message: 'Selected ' + slotUsed + ' RAM sticks, but ' + (slotProviderTitle || 'your motherboard') + ' only has ' + slotCapacity + ' slot' + (slotCapacity === 1 ? '' : 's') + '.'
        });
      });
    }

    return conflicts;
  };

  BuildYourPC.prototype.renderSidebar = function () {
    var self = this;
    var wrap = this.c.sidebar;
    wrap.innerHTML = '';
    var conflicts = this.computeConflicts();
    var conflictKeys = conflicts.map(function (c) { return c.categoryKey; });

    this.groupedCategories().forEach(function (group) {
      if (group.label) wrap.appendChild(el('p', { class: 'byp__group-label', text: group.label }));
      group.categories.forEach(function (cat) {
        var idx = self.categories.indexOf(cat);
        var picked = self.selectedOptionsForCategory(cat);
        var choiceText = picked.length
          ? picked.map(function (r) { return r.option.title + (r.qty > 1 ? ' \u00d7' + r.qty : ''); }).join(', ')
          : (cat.required ? 'Choose an option' : (self.settings.labels.included || 'Not selected'));
        var deltaCents = picked.reduce(function (sum, r) { return sum + r.option.price * r.qty; }, 0);
        var deltaText = '';
        if (picked.length) {
          var allDefault = picked.every(function (r) { return r.option.defaultSelected; });
          deltaText = allDefault ? (self.settings.labels.included || 'Included') : ('+' + self.money(deltaCents));
        }
        var item = el('button', {
          type: 'button',
          class: 'byp__cat-item',
          'aria-current': idx === self.activeIndex ? 'true' : 'false',
          'data-complete': self.categoryComplete(cat) ? 'true' : 'false',
          'data-conflict': conflictKeys.indexOf(cat.key) > -1 ? 'true' : 'false',
          onclick: function () { self.goTo(idx); }
        }, [
          el('span', { class: 'byp__cat-dot' }),
          el('span', { class: 'byp__cat-text' }, [
            el('span', { class: 'byp__cat-name', text: cat.title }),
            el('br'),
            el('span', { class: 'byp__cat-choice', text: choiceText })
          ]),
          el('span', { class: 'byp__cat-delta', text: deltaText })
        ]);
        wrap.appendChild(item);
      });
    });
  };

  BuildYourPC.prototype.renderSteps = function () {
    var self = this;
    var wrap = this.c.steps;
    wrap.innerHTML = '';
    this.categories.forEach(function (cat, idx) {
      wrap.appendChild(el('button', {
        type: 'button',
        class: 'byp__step-pill',
        'aria-current': idx === self.activeIndex ? 'true' : 'false',
        'data-complete': self.categoryComplete(cat) ? 'true' : 'false',
        text: cat.title,
        onclick: function () { self.goTo(idx); }
      }));
    });
  };

  BuildYourPC.prototype.goTo = function (idx) {
    if (idx < 0 || idx >= this.categories.length) return;
    this.activeIndex = idx;
    this.renderSidebar();
    this.renderSteps();
    this.renderMain();
  };

  BuildYourPC.prototype.renderMain = function () {
    var self = this;
    var cat = this.categories[this.activeIndex];
    if (!cat) return;
    this.c.crumb.textContent = (cat.group ? cat.group + ' \u00b7 ' : '') + cat.title;
    this.c.catTitle.textContent = cat.title;
    if (cat.helper) { this.c.catHelper.textContent = cat.helper; this.c.catHelper.hidden = false; }
    else { this.c.catHelper.hidden = true; }
    this.c.prev.disabled = this.activeIndex === 0;
    var isLast = this.activeIndex === this.categories.length - 1;
    this.c.nextLabel.textContent = isLast
      ? (this.settings.labels.reviewStep || 'Review your build')
      : ('Next: ' + this.categories[this.activeIndex + 1].title);
    this.c.pagerCount.textContent = (this.activeIndex + 1) + ' of ' + this.categories.length;

    this.renderGrid(cat);
  };

  BuildYourPC.prototype.sortOptions = function (options, mode) {
    var copy = options.slice();
    if (mode === 'price-asc') copy.sort(function (a, b) { return a.price - b.price; });
    else if (mode === 'price-desc') copy.sort(function (a, b) { return b.price - a.price; });
    return copy;
  };

  BuildYourPC.prototype.renderGrid = function (cat) {
    var self = this;
    var grid = this.c.grid;
    grid.innerHTML = '';
    var options = this.sortOptions(cat.options, this.c.sort.value);
    this.c.empty.hidden = options.length > 0;
    var sel = this.selections[cat.key] || {};

    options.forEach(function (opt) {
      var qty = sel[opt.id] || 0;
      var isSelected = qty > 0;
      var card = el('div', {
        class: 'byp__card',
        'data-selected': isSelected ? 'true' : 'false',
        'data-unavailable': opt.available ? 'false' : 'true',
        role: 'button',
        tabindex: '0'
      });

      if (opt.badge) card.appendChild(el('span', { class: 'byp__card-badge', text: opt.badge }));
      card.appendChild(el('span', { class: 'byp__card-check', html: '&#10003;' }));
      if (opt.image) card.appendChild(el('img', { class: 'byp__card-img', src: opt.image, alt: opt.title, loading: 'lazy' }));
      else card.appendChild(el('div', { class: 'byp__card-img' }));
      card.appendChild(el('p', { class: 'byp__card-title', text: opt.title }));
      if (opt.spec) card.appendChild(el('p', { class: 'byp__card-spec', text: opt.spec }));
      card.appendChild(el('p', {
        class: 'byp__card-price',
        'data-free': opt.price === 0 ? 'true' : 'false',
        text: opt.price === 0 ? (self.settings.labels.included || 'Included') : ('+' + self.money(opt.price))
      }));
      if (!opt.available) card.appendChild(el('p', { class: 'byp__card-sold', text: self.settings.labels.soldOut || 'Sold out' }));
      if (opt.note) card.appendChild(el('p', { class: 'byp__card-note', text: opt.note }));

      var handleSelect = function () {
        if (!opt.available) return;
        if (cat.selectionMode === 'multi') return; // handled by qty controls
        self.selections[cat.key] = {};
        self.selections[cat.key][opt.id] = 1;
        self.afterChange();
      };
      card.addEventListener('click', function (e) {
        if (e.target.closest('[data-byp-qty]')) return;
        handleSelect();
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleSelect(); }
      });

      if (cat.selectionMode === 'multi') {
        var qtyWrap = el('div', { class: 'byp__qty', 'data-byp-qty': 'true' });
        var controls = el('div', { class: 'byp__qty-controls' }, [
          el('button', {
            type: 'button', class: 'byp__qty-btn', text: '\u2212',
            onclick: function () {
              if (!opt.available) return;
              var current = self.selections[cat.key][opt.id] || 0;
              if (current <= 1) delete self.selections[cat.key][opt.id];
              else self.selections[cat.key][opt.id] = current - 1;
              self.afterChange();
            }
          }),
          el('span', { class: 'byp__qty-val', text: String(qty) }),
          el('button', {
            type: 'button', class: 'byp__qty-btn', text: '+',
            onclick: function () {
              if (!opt.available) return;
              self.selections[cat.key][opt.id] = (self.selections[cat.key][opt.id] || 0) + 1;
              self.afterChange();
            }
          })
        ]);
        qtyWrap.appendChild(controls);
        card.appendChild(qtyWrap);
      }

      grid.appendChild(card);
    });
  };

  BuildYourPC.prototype.afterChange = function () {
    this.saveState();
    this.renderSidebar();
    this.renderSteps();
    var cat = this.categories[this.activeIndex];
    this.renderGrid(cat);
    this.renderSummary();
  };

  BuildYourPC.prototype.renderSummary = function () {
    var self = this;
    var totals = this.computeTotals();
    var conflicts = this.computeConflicts();
    var power = this.computePower();

    // Preview image + build name/spec
    var previewCat = this.categories.filter(function (c) { return c.isPreviewSource; })[0];
    var previewOpt = previewCat ? this.firstSelected(previewCat) : null;
    if (previewOpt && previewOpt.image) {
      this.c.previewImg.src = previewOpt.image;
      this.c.previewImg.hidden = false;
      this.c.previewPlaceholder.hidden = true;
    } else {
      this.c.previewImg.hidden = true;
      this.c.previewPlaceholder.hidden = false;
    }

    var specParts = [];
    this.categories.filter(function (c) { return c.isHighlighted; }).forEach(function (c) {
      var o = self.firstSelected(c);
      if (o) specParts.push(o.title);
    });
    this.c.buildSpec.textContent = specParts.join(' \u00b7 ');
    this.c.buildName.textContent = this.settings.buildName || 'Custom Build';

    this.c.totalPrice.textContent = this.money(totals.total);
    this.c.mobilePrice.textContent = this.money(totals.total);
    var upgradeLabel = totals.upgradeCount === 1 ? (this.settings.labels.upgradesLabel || 'upgrade') : (this.settings.labels.upgradesLabelPlural || 'upgrades');
    this.c.priceBreakdown.textContent = (this.settings.labels.baseLabel || 'Base') + ' ' + this.money(totals.base) +
      (totals.upgradeCount ? ' \u00b7 ' + totals.upgradeCount + ' ' + upgradeLabel + ' +' + this.money(totals.upgradeTotal) : '');

    // Power meter
    if (this.c.power) {
      if (power.hasSupplier && power.capacity > 0) {
        this.c.power.hidden = false;
        var pct = Math.min(100, Math.round((power.draw / power.capacity) * 100));
        var warnT = this.settings.powerWarnThreshold || 80;
        var dangerT = this.settings.powerDangerThreshold || 100;
        var state = pct >= dangerT ? 'danger' : (pct >= warnT ? 'warn' : 'good');
        var label = state === 'danger' ? this.settings.labels.powerOver : (state === 'warn' ? this.settings.labels.powerHigh : this.settings.labels.powerGood);
        this.c.powerLabel.textContent = label;
        this.c.powerValue.textContent = power.draw + 'W / ' + power.capacity + 'W';
        this.c.powerFill.style.width = pct + '%';
        this.c.powerFill.setAttribute('data-state', state === 'good' ? '' : state);
        this.c.power.querySelector('.byp__power-row').setAttribute('data-state', state === 'good' ? '' : state);
      } else {
        this.c.power.hidden = true;
      }
    }

    // Lines
    this.c.lines.innerHTML = '';
    var conflictKeys = conflicts.map(function (c) { return c.categoryKey; });
    this.categories.forEach(function (cat) {
      var picked = self.selectedOptionsForCategory(cat);
      if (!picked.length) return;
      picked.forEach(function (row) {
        var line = el('div', { class: 'byp__line', 'data-conflict': conflictKeys.indexOf(cat.key) > -1 ? 'true' : 'false' }, [
          el('div', {}, [
            el('span', { class: 'byp__line-label', text: cat.title }),
            el('span', { class: 'byp__line-value', text: row.option.title + (row.qty > 1 ? ' \u00d7 ' + row.qty : '') })
          ]),
          el('span', { class: 'byp__line-price', text: row.option.price === 0 ? (self.settings.labels.included || 'Included') : self.money(row.option.price * row.qty) })
        ]);
        self.c.lines.appendChild(line);
      });
    });

    // Warnings
    var missingRequired = this.categories.filter(function (c) { return c.required && !self.categoryComplete(c); });
    if (conflicts.length) {
      this.c.warning.hidden = false;
      var msg = conflicts.length === 1
        ? this.settings.labels.conflictSingle
        : (this.settings.labels.conflictMulti || '').replace(/\{n\}/g, conflicts.length);
      this.c.warningText.textContent = msg;
      this.c.warningList.innerHTML = '';
      conflicts.forEach(function (c) { self.c.warningList.appendChild(el('li', { text: c.message })); });
    } else {
      this.c.warning.hidden = true;
    }

    var canAdd = conflicts.length === 0 && missingRequired.length === 0;
    this.c.addToCart.disabled = !canAdd;
    this.c.mobileAdd.disabled = !canAdd;

    // sync sidebar dot states without full re-render loop risk
  };

  BuildYourPC.prototype.bindGlobalEvents = function () {
    var self = this;

    this.c.sort.addEventListener('change', function () { self.renderGrid(self.categories[self.activeIndex]); });

    this.c.prev.addEventListener('click', function () { self.goTo(self.activeIndex - 1); });
    this.c.next.addEventListener('click', function () {
      if (self.activeIndex < self.categories.length - 1) self.goTo(self.activeIndex + 1);
      else self.openDrawerPreview();
    });

    this.c.reset.addEventListener('click', function () {
      try { window.localStorage.removeItem(self.storageKey); } catch (e) {}
      self.selections = {};
      self.categories.forEach(function (cat) {
        self.selections[cat.key] = {};
        cat.options.forEach(function (opt) {
          if (opt.defaultSelected && opt.available) self.selections[cat.key][opt.id] = 1;
        });
      });
      self.saveState();
      self.activeIndex = 0;
      self.renderSidebar();
      self.renderSteps();
      self.renderMain();
      self.renderSummary();
    });

    this.c.warningToggle.addEventListener('click', function () {
      var isHidden = self.c.warningList.hidden;
      self.c.warningList.hidden = !isHidden;
    });

    this.c.addToCart.addEventListener('click', function () { self.addToCart(); });
    this.c.mobileAdd.addEventListener('click', function () { self.addToCart(); });

    this.mobileExpandLabel = this.c.mobileExpand.textContent.replace(/[\u25b2\u25bc]/g, '').trim();
    this.c.mobileExpand.addEventListener('click', function () {
      var willOpen = self.root.getAttribute('data-summary-open') !== 'true';
      self.root.setAttribute('data-summary-open', willOpen ? 'true' : 'false');
      self.c.mobileExpand.textContent = self.mobileExpandLabel + ' ' + (willOpen ? '\u25b2' : '\u25bc');
    });

    this.c.drawerClose.addEventListener('click', function () { self.closeDrawer(); });
    this.c.continueBtn.addEventListener('click', function () { self.closeDrawer(); });
    this.c.overlay.addEventListener('click', function (e) { if (e.target === self.c.overlay) self.closeDrawer(); });
  };

  BuildYourPC.prototype.openDrawerPreview = function () {
    // On last step "Review your build" just jump summary open on mobile
    if (window.matchMedia('(max-width: 999px)').matches) {
      this.root.setAttribute('data-summary-open', 'true');
    }
  };

  BuildYourPC.prototype.closeDrawer = function () {
    this.c.overlay.hidden = true;
  };

  BuildYourPC.prototype.buildCartItems = function () {
    var items = [];
    this.categories.forEach(function (cat) {
      this.selectedOptionsForCategory(cat).forEach(function (row) {
        if (!row.option.variantId) return;
        items.push({
          id: row.option.variantId,
          quantity: row.qty,
          properties: {
            'Build component': cat.title,
            'Build name': this.settings.buildName || 'Custom Build'
          }
        });
      }, this);
    }, this);
    return items;
  };

  BuildYourPC.prototype.addToCart = function () {
    var self = this;
    var conflicts = this.computeConflicts();
    var missingRequired = this.categories.filter(function (c) { return c.required && !self.categoryComplete(c); });
    if (conflicts.length || missingRequired.length) return;

    var items = this.buildCartItems();
    if (!items.length) return;

    this.c.addToCart.disabled = true;
    this.c.mobileAdd.disabled = true;
    var originalText = this.c.addToCart.textContent;
    this.c.addToCart.textContent = '\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) { if (!res.ok) throw new Error('cart-add-failed'); return res.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (res) { return res.json(); })
      .then(function (cart) { self.openOrderSummary(cart); })
      .catch(function () {
        self.c.addToCart.textContent = self.settings.labels.addToCartError || 'Try again';
        setTimeout(function () { self.c.addToCart.textContent = originalText; }, 2200);
      })
      .finally(function () {
        self.c.addToCart.disabled = false;
        self.c.mobileAdd.disabled = false;
        if (self.c.addToCart.textContent === '\u2026') self.c.addToCart.textContent = originalText;
      });
  };

  BuildYourPC.prototype.openOrderSummary = function (cart) {
    var self = this;
    this.c.drawerBody.innerHTML = '';
    var buildKeys = {};
    this.categories.forEach(function (cat) {
      self.selectedOptionsForCategory(cat).forEach(function (row) {
        buildKeys[row.option.variantId] = true;
      });
    });

    (cart.items || []).forEach(function (item) {
      var row = el('div', { class: 'byp__drawer-item' }, [
        item.image ? el('img', { src: item.image, alt: item.title }) : el('div', { style: 'width:52px;height:52px' }),
        el('div', { class: 'byp__drawer-item-info' }, [
          el('p', { class: 'byp__drawer-item-title', text: item.product_title || item.title }),
          el('p', { class: 'byp__drawer-item-meta', text: 'Qty ' + item.quantity })
        ]),
        el('span', { class: 'byp__drawer-item-price', text: self.money(item.final_line_price) })
      ]);
      self.c.drawerBody.appendChild(row);
    });

    this.c.drawerTotal.textContent = this.money(cart.total_price);
    this.c.overlay.hidden = false;
  };

  function initAll() {
    document.querySelectorAll('[data-byp-root]').forEach(function (node) {
      if (node.dataset.bypInit === 'true') return;
      node.dataset.bypInit = 'true';
      new BuildYourPC(node);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var node = e.target.querySelector ? e.target.querySelector('[data-byp-root]') : null;
    if (node) { node.dataset.bypInit = 'true'; new BuildYourPC(node); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
